import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";

import { cn } from "~/core/generic/shadcn-utils";

import type { IconProp } from "@fortawesome/fontawesome-svg-core";

interface ShortcutIconsProps {
  icons?: IconProp[];
  variant?: "primary" | "outlined";
}

const ShortcutIcons: React.FC<ShortcutIconsProps> = ({
  icons,
  variant = "primary",
}) => {
  if (icons?.length === 0) return null;
  return (
    <div className="flex items-center justify-between gap-1 ml-1 h-full">
      {icons?.map((icon, index) => (
        <div
          key={index}
          className={cn(
            "flex flex-col items-center justify-center rounded-base size-4",
            {
              "bg-base-12/20 text-white/80": variant === "primary",
              "border border-core-silver-3 bg-base-12 text-lighter":
                variant === "outlined",
            },
          )}
        >
          <FontAwesomeIcon icon={icon} className="size-2" />
        </div>
      ))}
    </div>
  );
};

export default ShortcutIcons;
